'use es6';

import { render } from 'foundations-components/transitional/utils/customRenderer';
import { lazyEval } from 'foundations-components/transitional/utils/lazyEval';
import { Component } from 'react';

export default class SingleNameInput extends Component {
  render() {
    const { input, label, ...passThroughProps } = this.props;
    return render(
      input,
      {
        label: lazyEval(label),
        ...passThroughProps,
        ...input.props,
      },
      {
        mergeType: 'aggressive',
      }
    );
  }
}
